import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Leaf, Users, Heart } from 'lucide-react';

export const SustainabilitySection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-[#F5F3F0] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#C4B5A0] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#6B4E37] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Content Side */}
          <div className="space-y-6 fade-in-up">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] leading-tight">
              {t('sustainabilityTitle')}
            </h2>
            
            <blockquote className="border-l-4 border-[#C4B5A0] pl-6 italic text-xl text-[#6B4E37] font-serif">
              "{t('sustainabilityQuote')}"
            </blockquote>
            
            <p className="text-lg text-[#8B7D6B] leading-relaxed">
              {t('sustainabilityText')}
            </p>

            {/* Values */}
            <div className="space-y-4 pt-4">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#C4B5A0]/20 rounded-lg">
                  <Leaf className="h-6 w-6 text-[#6B4E37]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#2C2C2C] mb-1">Eco-Conscious Tourism</h4>
                  <p className="text-sm text-[#8B7D6B]">Minimizing footprint, maximizing impact</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#C4B5A0]/20 rounded-lg">
                  <Users className="h-6 w-6 text-[#6B4E37]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#2C2C2C] mb-1">Community Partnership</h4>
                  <p className="text-sm text-[#8B7D6B]">Supporting local livelihoods and traditions</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#C4B5A0]/20 rounded-lg">
                  <Heart className="h-6 w-6 text-[#6B4E37]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#2C2C2C] mb-1">Cultural Preservation</h4>
                  <p className="text-sm text-[#8B7D6B]">Protecting heritage for future generations</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Side */}
          <div className="relative fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src="https://images.pexels.com/photos/3145866/pexels-photo-3145866.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Local Artisan"
                className="w-full h-[500px] object-cover transform hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#6B4E37]/30 to-transparent"></div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#C4B5A0] rounded-full opacity-20 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};